import React, { useState, useEffect } from "react";
import RatingGameNumberSense from "../../components/RatingGameNumberSense";
import useGame from "../../hooks/useGame";
import useRatingQuestions from "../../hooks/useRatingQuestions";
import { navigate } from "@reach/router";
import LoadingScreen from "../../components/LoadingScreen";


function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

function GenerateUniqueRandom(min, max, notthisArray) {
  var returnMe = Math.floor(Math.random() * (max - min) + min);
  console.log(notthisArray)

  if (notthisArray.includes(returnMe)) {
    return GenerateUniqueRandom(min, max, notthisArray);
  }

  return returnMe;
}

function GenerateRandom(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

function GenerateQuestion(q) {
  var question;
  var image;
  var questionAnswers = [];
  var time = "";
  var questionHTML = "";
  var parameters = q.image_parameter.split(",");//split parameters
  console.log(q);
  //check image object to determine if subitising subject
  if (q.image != "a b c" && q.image != "Objects" && q.image != "abc") {
    question = q.question_line_1;
    if (q.time_on_screen != "") {
      console.log("SET TIME");
      time = q.time_on_screen.substring(0, q.time_on_screen.length - 1);
      console.log(q.time_on_screen);
      console.log(time);
      
    }
    var answerNumber = GenerateRandom(parseInt(parameters[1]), parseInt(parameters[2]));//generate answer
    //image = q.image + answerNumber + ".png";//image = imagename plus number such as "Emile2.png"
    image = q.image.toLowerCase() + answerNumber + ".png";
    var answers = [];
    answers.push(answerNumber);//add correct
    for (let i = 0; i < 3; i++) {//generate wrong
      var wrong = GenerateUniqueRandom(parseInt(parameters[1]), parseInt(parameters[2]) + 2, answers)//wrong is random range plus 1
      answers.push(wrong);
      questionAnswers.push({
        correct: false,
        value: wrong
      });
    }
    questionAnswers.push({
      correct: true,
      value: answerNumber
    });
  } else {
    //number bonds
    if (q.image == "a b c" || q.image == "abc") {
      console.log("number bonds");
      //set generated total number
      var total = GenerateRandom(parseInt(parameters[1]), parseInt(parameters[2]));
      question = q.question_line_1.replace("$", total);//set question line
      //generate number "a" = 1-total
      //number b = total - a
      //number c = random number that isnt a or b
      var a = GenerateRandom(1, total - 1);
      var b = total - a;
      var usedNumbers = [];
      usedNumbers.push(a);
      if (a != b) {
        usedNumbers.push(b);
      }
      console.log(total);
      console.log(usedNumbers);
      var c = GenerateUniqueRandom(1, total + 1, usedNumbers);
      //push right answer
      questionAnswers.push({
        correct: true,
        value: a + "," + b
      });
      questionAnswers.push({
        correct: false,
        value: b + "," + c
      });
      questionAnswers.push({
        correct: false,
        value: c + "," + a
      });
      //create html of numbers
      var numbers = []
      numbers.push(a, b, c);
      shuffleArray(numbers);
      questionHTML = "<div style='font-size:200px; text-shadow:3px 2px #000000;color:white'>" + numbers[0] + "  " + numbers[1] + "  " + numbers[2] + "</div>";
    }
    else {
      if (q.topic_key == "NSense8" || q.topic_key == "NSense9") {//addition & subtraction level 1
        var num1 = GenerateRandom(parseInt(parameters[1]), parseInt(parameters[2]));//$
        var numused = [];
        numused.push(num1);
        var num2 = GenerateUniqueRandom(parseInt(parameters[4]), parseInt(parameters[5]), numused);//%
        if (q.topic_key == "NSense9"){
          num2 = GenerateUniqueRandom(parseInt(parameters[4]), num1, numused);//%
        }
        question = q.question_line_1.replace("$", num1);//replace $ with question_line_1
        question = question.replace("%", num2);
        var answer;
        if (question.includes("+")) {//addition answer
          answer = num1 + num2;
        } else {
          answer = num1 - num2;
        }
        var numbersUsed = []
        numbersUsed.push(answer);
        //wrong one = $, wrong two = %, wrong 3 = a - b or 0 if lower OR IF minus then add
        questionAnswers.push({
          correct: false,
          value: num1
        });
        if (num2 != answer) {
          questionAnswers.push({
            correct: false,
            value: num2
          });
        }else{
          questionAnswers.push({
            correct: false,
            value: GenerateUniqueRandom(1,9,numbersUsed)
          });
        }
        var wrong3 = num1 - num2;
        if (question.includes("+")) {
          if (wrong3 < 0) {
            wrong3 = num2 - num1;
          }
          if (wrong3 < 0) {
            wrong3 = 0;
          }
        } else {
          wrong3 = num1 + num2;
        }

        questionAnswers.push({
          correct: false,
          value: wrong3
        });
        questionAnswers.push({
          correct: true,
          value: answer
        });


      } else {//add sub level 2
        var num1 = GenerateRandom(parseInt(parameters[1]), parseInt(parameters[2]));//$
        var num2 = GenerateRandom(parseInt(parameters[4]), parseInt(parameters[5]));//%
        //sometimes it is % generated and sometimes it is ? generated, need to look into that
        if (q.topic_key == "NSense10") {
          question = q.question_line_1.replace("$", num1);
          answer = num2;
          question = question.replace("%", num1 + num2);
          var numbersUsed = []
          numbersUsed.push(answer);
          for (let i = 0; i < 3; i++) {
            var wrong = GenerateUniqueRandom(parseInt(parameters[1]), parseInt(parameters[2]), numbersUsed)
            questionAnswers.push({
              correct: false,
              value: wrong
            });
            numbersUsed.push(wrong);
          }
          questionAnswers.push({
            correct: true,
            value: answer
          });

        } else if (q.topic_key == "NSense11") {
          console.log("help");
          console.log(num1);
          num2 = GenerateRandom(parseInt(parameters[4]),num1);
          console.log(num2);
          question = q.question_line_1.replace("$", num1);
          question = question.replace("%", num2);
          var answer = num1 - num2;
          var numbersUsed = []
          numbersUsed.push(answer);
          for (let i = 0; i < 3; i++) {
            var wrong = GenerateUniqueRandom(parseInt(parameters[1]), parseInt(parameters[2]), numbersUsed)
            questionAnswers.push({
              correct: false,
              value: wrong
            });
            numbersUsed.push(wrong);
          }
          questionAnswers.push({
            correct: true,
            value: answer
          });
        }
      }
    }
  }

  shuffleArray(questionAnswers);

  let questionObj = {
    question: question,
    answers: questionAnswers,
    time: time,
    image: image,
    questionHTML: questionHTML,
    topic_id: q.topic_id
  };

  console.log(questionObj);
  return questionObj;
}

export default function Rating({ ...props }) {
  const game = useGame(props.game.id);
  const { questions } = useRatingQuestions({ game_type: game.game_type }, game);
  const [levels, setLevels] = useState();
  //console.log("Questions");
  //console.log(questions);

  // once the questions have been retrieved we then generate the questionlist for the rating game
  useEffect(() => {
    if (questions !== undefined) {
      let levelQs = [];
      questions.forEach((levelQuestions, i) => {

        var newLevelQuestions = [];
        levelQuestions.forEach(q => {
          console.log(q);
          console.log(q.right_answer);
          for (var i = 1; i < 12; i++) {
            var questionObj = GenerateQuestion(q);
            newLevelQuestions.push(questionObj);
          }
        });
        shuffleArray(newLevelQuestions);
        levelQs[i] = newLevelQuestions;
      });
      setLevels(levelQs);
    }
    console.log("ALL LEVELS");
    console.log(levels);
  }, [questions]);

  return levels !== undefined ? (
    <RatingGameNumberSense
      questionslist={levels}
      onBack={() => {
        navigate(`/games/${game.id}`);
      }}
      game={game}
      endless={props.endless}
      initialLevel={props.initialLevel}
    />
  ) : (
      <LoadingScreen />
    );
}
